import { render, staticRenderFns } from "./consolidated-region.vue?vue&type=template&id=29c216b4&scoped=true"
import script from "./consolidated-region.vue?vue&type=script&lang=js"
export * from "./consolidated-region.vue?vue&type=script&lang=js"
import style0 from "./consolidated-region.vue?vue&type=style&index=0&id=29c216b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c216b4",
  null
  
)

export default component.exports